import { Outlet } from 'react-router-dom';
import Footer from '../Footer';

const BlogLayout = () => {
  return (
    <div className="min-h-screen w-full overflow-x-hidden m-0 p-0">
      {/* Navigation */}
      <nav className="fixed top-0 z-50 w-full">
        <div 
          className="w-full"
          style={{
            backgroundImage: 'url(/nav-bg.svg)',
            backgroundSize: 'auto 120%',
            backgroundPosition: 'center',
            backgroundRepeat: 'repeat',
          }}
        >
          <div className="max-w-full sm:max-w-[90%] xl:max-w-[70rem] mx-auto px-4 sm:px-6 xl:px-6 relative">
            <div className="flex items-center justify-between h-16 lg:h-24">
              {/* Logo */}
              <div className="hidden lg:block">
                <a href="/" className="flex items-center">
                  <img src="/Logo.svg" alt="Plottie Logo" className="h-12 w-auto" />
                </a>
              </div>

              {/* Mobile logo */}
              <div className="lg:hidden">
                <a href="/" className="flex items-center">
                  <img src="/Logo.svg" alt="Plottie Logo" className="h-8 w-auto" />
                </a>
              </div>

              {/* CTA Button */}
              <div className="hidden lg:block">
                <a href="/erstellen" className="px-5 py-3 bg-[#FFA23E] text-[#343434] rounded-full font-freeman text-lg md:tracking-[-0.04rem] hover:bg-[#ff9625] transition-all duration-300">
                  Geschichte erstellen
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      {/* Blog Content */}
      <div className="">
        <Outlet />
      </div>

      <Footer />
    </div>
  );
};

export default BlogLayout; 